// import hooks
import { useEffect, useState } from "react";
export const useDebounceHook = (value, options) => {
    const { delay = 300, onDebounce } = { ...options };
    const [debouncedValue, setDebouncedValue] = useState(value);
    useEffect(() => {
        const debounce = setTimeout(() => {
            setDebouncedValue(value);
            onDebounce?.(value);
        }, delay);
        return () => {
            clearTimeout(debounce);
        };
    }, [value, delay, onDebounce]);
    return debouncedValue;
};
export default useDebounceHook;
